import React from "react";

export default function ForgotPasswordForm({
  email,
  setEmail,
  onSubmit,
  onBack,
  isLoading = false,
  error = "",
  successMessage = "",
}) {
  return (
    <>
      <div className="login-header">
        <button className="back" onClick={onBack} aria-label="Back to Login">
          ←
        </button>
        <div className="header-title">Forgot Password</div>
      </div>

      <form className="login-form" onSubmit={onSubmit}>
        <p className="form-note">
          Enter your promoter email. If the account exists, you will receive a reset link.
        </p>

        <label className="login-field-label">
          Email <span className="required-asterisk" aria-hidden="true">*</span>
        </label>
        <input
          type="email"
          placeholder="Email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          disabled={isLoading}
        />

        {error && (
          <div className="form-feedback form-feedback-error" role="alert">
            {error}
          </div>
        )}

        {successMessage && (
          <div className="form-feedback form-feedback-success" role="status">
            {successMessage}
          </div>
        )}

        <button className="submit" type="submit" disabled={isLoading}>
          {isLoading ? "Sending..." : "Send Reset Link"}
        </button>
      </form>
    </>
  );
}
